import React from "react";
import { Link } from "react-router-dom";

// Plain-DOM hero that matches the markup in index.html's pre-rendered shell.
// No framer-motion, no entrance animations, no second image fetch — so when
// React mounts on the homepage the hero stays exactly where it was painted
// from the HTML shell. This eliminates the LCP re-paint and the navbar-
// induced layout shift that the framer-motion <Hero> caused.
//
// Visual parity with the shell markup is intentional: the shell's inline CSS
// (#prerender-hero { ... }) styles this exact tree.
export default function PrerenderedHero() {
  return (
    <section id="prerender-hero" aria-hidden="false">
      <div className="ph-bg">
        <img
          src="https://media.topnotch-contractors.com/topnotch/5adcd72f6_mt-washington-modern-kitchen.webp"
          alt="Baltimore kitchen remodel by Top-Notch Contractors"
          width="1600"
          height="900"
          fetchPriority="high"
          decoding="async"
        />
        <div className="ph-overlay" />
      </div>
      <div className="ph-inner">
        <div className="ph-wrap">
          <p className="ph-kicker">Baltimore's Trusted General Contractor</p>
          <h1>
            Baltimore's Trusted Remodeling Contractor{" "}
            <span className="ph-italic">Since 2010</span>
          </h1>
          <p className="ph-sub">
            Kitchens, bathrooms, basements, and whole-house renovations across Baltimore County.
            Licensed, insured, and on time — every time.
          </p>
          <div className="ph-cta-row">
            <Link className="ph-btn ph-btn-primary" to="/contact">Book a Consultation</Link>
            <Link className="ph-btn ph-btn-outline" to="/portfolio">See Our Work</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
